import UserSignupGrid from "./components/UserGrid";

export default function SignupPage() {
  return <UserSignupGrid />;
}
